<template lang="pug">
  div
    h1 Today, {{today}}:
    p Donald Trump is on 🔥 with an approval rating of&nbsp;
      span(class="approve") {{Number(dataToday.approve_estimate).toFixed(1) }}%
      span &nbsp;and disapproval of&nbsp;
      span(class="disapprove") {{Number(dataToday.disapprove_estimate).toFixed(1) }}%
    p
      icon(v-if="busy" name="refresh" scale="3" spin)
    p(v-if="dataToday.approve_estimate < 60")
      | A great big
      span(style="color:#F00;text-transform:uppercase;")
        | &nbsp;Fail!!
    p
      a(target='_blank' rel='noopener' href='https://projects.fivethirtyeight.com/trump-approval-ratings/') Trump Approvial Ratings&nbsp;
      sup @538
</template>

<script>
import * as moment from 'moment'

export default {
  name: 'approval',
  data () {
    return {
      approvalData: null,
      busy: true,
      todayDataFormat: moment().format('YYYY-MM-DD'),
      today: moment().format('MMM, Do, YYYY'),
      dataToday: {},
      approve: '',
      disapprove: ''
    }
  },
  methods: {
    currentApproval (approval) {
      return approval.date === this.todayDataFormat && approval.subgroup === 'All polls'
    },
    async getApproval () {
      const url = 'https://projects.fivethirtyeight.com/trump-approval-ratings/approval.json'
      const response = await fetch(url)
      this.approvalData = await response.json()
      this.dataToday = this.approvalData.filter(this.currentApproval)[0]
      this.busy = await false
    }
  },
  async created () {
    this.getApproval()
  }
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// Approval.vue?1948abc3